
class CacheService {
  constructor() { }

  static origin(key, type) {
    let item = type ? window.localStorage.setItem(key) : window.sessionStorage.getItem(key)
    return item !== null && JSON.parse(item) || void 0
  }

  static get(key) {
    let item
    return (item = window.sessionStorage.getItem(key)) !== null ?
      JSON.parse(item) : (item = window.localStorage.getItem(key)) === null ?
        void 0 : JSON.parse(item).data
  }

  static set(key, value, type) {
    if (type) {
      window.sessionStorage.setItem(key, JSON.stringify(value),)
    } else {
      window.localStorage.setItem(key, JSON.stringify({
        data: value,
        timestamp: Date.now()
      }))
    }
  }

  static remove(key) {
    window.sessionStorage.removeItem(key)
    window.localStorage.removeItem(key)
  }

  static clear() {
    window.sessionStorage.clear()
    window.localStorage.clear()
  }

}

export default CacheService